import {
  DataFromStorageSetter,
  IPendingConfigStorage,
  ISettingsStorage,
} from "@/services/storage/base/storage-abstractions";
import {
  BasePendingConfig,
  PendingConfigStorageMixin,
} from "@/services/storage/storage-mixins/pending-config-storage-mixin";
import React from "react";

import {
  ConvertBaseSettingsField,
  ConvertBaseSettingsStorageMixin,
} from "@/services/storage/storage-mixins/settings-mixins/convert-base-settings-storage-mixin";
import { ConvertBaseSettings } from "@/hooks/ai-tool-process/use-convert-base-context-provider";
import { MediaInputStorage } from "@/services/storage/base/media-input-storage";

export abstract class ConvertBaseStorage<
    TSettings extends ConvertBaseSettings,
    TConfig extends BasePendingConfig,
    TSettingsField extends ConvertBaseSettingsField,
    TSettingsStorage extends ConvertBaseSettingsStorageMixin<TSettingsField>,
  >
  extends MediaInputStorage
  implements
    ISettingsStorage<TSettingsField>,
    IPendingConfigStorage<TConfig>,
    DataFromStorageSetter<TSettings>
{
  pendingConfigStorage: PendingConfigStorageMixin<TConfig>;
  abstract settingStorage: TSettingsStorage;

  protected constructor(storeName: string, databaseName: string) {
    super(storeName, databaseName);
    this.pendingConfigStorage = new PendingConfigStorageMixin<TConfig>(
      this.storeName,
      this.databaseName,
    );
  }

  async setDataFromStorage(
    setSettings: (value: React.SetStateAction<TSettings>) => void,
  ): Promise<void> {
    const sessionSettings = await this.settingStorage.getSettings();

    setSettings((prevState) => ({
      ...prevState,
      ...this.setDataFromStorageInternal(sessionSettings),
      conversionEffects: {
        ...prevState.conversionEffects,
        pitchSettings: {
          ...prevState.conversionEffects.pitchSettings,
          pitchLevel: {
            ...prevState.conversionEffects.pitchSettings.pitchLevel,
            value: sessionSettings.pitch ?? 0,
          },
        },
      },
      vocalIsolationSettings: {
        removeReverbAndEcho: sessionSettings.removeReverb ?? false,
        separateInstruments: true,
        //separateInstruments: sessionSettings.removeInstrumentals ?? false,
      },
    }));
  }

  protected setDataFromStorageInternal(
    sessionSettings: any,
  ): Record<string, any> {
    return {};
  }
}
